import axios from './axios.service'
import jwt from 'jsonwebtoken'

import Cookies from 'js-cookie'

class AuthService {
  async login (user) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/user/login`,
        user
      )

      if (response.data.token) {
        const decoded = jwt.decode(response.data.token)
        Cookies.set('ow:user', decoded, { expires: 365 })
        Cookies.set('base:token', response.data.token, { expires: 365 })

        return decoded
      }
    } catch (error) {
      return error
    }
  }

  logout () {
    Cookies.remove('ow:user')
    Cookies.remove('base:token')
    Cookies.remove('ow:userId')
    Cookies.remove('ow:link')
  }

  async passReset (email) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/lostpassword`,
        { login: email }
      )
      return response.status
    } catch (error) {
      return error.response.status
    }
  }

  async passExpired (id) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/expired/${id}`
      )
      return response.data
    } catch (error) {
      return error.response.status
    }
  }

  async setNewPassword (data) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_URL}/lostpassword/newpassword`,
        { ...data }
      )
      return response.status
    } catch (error) {
      return error.response.status
    }
  }

  getAuth () {
    const token = Cookies.get('base:token')

    if (token) {
      return { Authorization: 'Bearer ' + token }
    } else {
      return {}
    }
  }
}

export default new AuthService()
